module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/253-seychelles-b1d0201f386e96f1454e0fa67793ee46.svg";